<template>
  <div class="ChangePassword min-h-screen flex flex-col lg:flex-row-reverse">
    <!--//v ChangePassword form container  -->
    <transition name="auth-form" appear>
      <div
        class="ChangePassword-form p-4 flex-1 flex flex-col md:p-8 lg:px-20 lg:py-6 2xl:py-24 lg:max-h-screen lg:overflow-y-auto"
      >
        <h1 class="font-minion text-xl text-primary-400 lg:text-3xl">
          Change Password
          <span class="block font-minion font-bold mt-0.5 lg:mt-2"
            >Ask a Fundraiser</span
          >
        </h1>

        <!-- //v form -->
        <form class="mt-5 flex-1 flex flex-col" @submit.prevent="onSubmitForm">
          <div class="flex-1">
            <div class="">
              <LoginFormInput
                input-label="New Password"
                label-for="cp-password-input"
                input-type="password"
                :is-password="true"
                input-id="cp-password-input"
                input-placeholder="Min. 8 Charachter"
                v-model.trim="formData.passwordVal"
                :inputClasses="`${
                  v$.passwordVal.$error
                    ? 'shakeX border-red-400 !outline-red-400 duration-300 !text-red-400 placeholder:!text-red-300'
                    : ''
                }`"
              />
              <transition name="auth-form">
                <p
                  class="pl-2 mt-1 text-sm text-red-400"
                  v-if="v$.passwordVal.$error"
                >
                  {{ v$.passwordVal.$errors[0].$message }}
                </p>
              </transition>
            </div>

            <div class="mt-4">
              <LoginFormInput
                input-label="Confirm New Password"
                label-for="cp-conf-password-input"
                input-type="password"
                :is-password="true"
                input-id="cp-conf-password-input"
                input-placeholder="Rewrite your Password"
                v-model.trim="formData.passwordConfVal"
                :inputClasses="`${
                  v$.passwordConfVal.$error
                    ? 'shakeX border-red-400 !outline-red-400 duration-300 !text-red-400 placeholder:!text-red-300'
                    : ''
                }`"
              />
              <transition name="auth-form">
                <p
                  class="pl-2 mt-1 text-sm text-red-400"
                  v-if="v$.passwordConfVal.$error"
                >
                  {{ v$.passwordConfVal.$errors[0].$message }}
                </p>
              </transition>
              <transition name="auth-form">
                <div
                  class="pl-2 mt-2 text-sm text-red-400"
                  v-if="messageContent == 'token is not valid.'"
                >
                  {{ messageContent }}

                  <a href="/forgot-password"> Reset your password again. </a>
                </div>
              </transition>
              <transition name="auth-form">
                <div
                  class="pl-2 mt-2 text-sm text-green-400"
                  v-if="messageContent == 'new password saved.'"
                >
                  {{ messageContent }}
                </div>
              </transition>
            </div>
            <!--//v form submit button -->
            <button
              class="w-full bg-[#00423D] font-minion text-[20px] text-white py-3 rounded-[8px] mt-6 font-bold lg:py-4 flex items-center justify-center"
              type="submit"
              ref="submitBtn"
            >
              <transition name="button-switch" mode="out-in">
                <span v-if="!isSendingRequest">Reset</span>
                <div
                  v-else
                  class="max-h-6 overflow-hidden inline-flex items-center justify-center pt-3"
                >
                  <Vue3Lottie
                    :animationData="buttonAnimation"
                    :height="120"
                    :width="120"
                  />
                </div>
              </transition>
            </button>

            <p class="font-minion text-placeholder text-[18px] md:text-base mt-2">
              Use 8 or more characters with a mix of letters, numbers and
              symbols. Must not contain your name or username.
            </p>
          </div>
        </form>
      </div>
    </transition>
    <AuthSlider />
  </div>
</template>
<script setup>
// v global
import global from "@/global";

//v Vue Imports
import { ref, onMounted, computed, reactive } from "vue";

//v Vue Router
import { RouterLink, RouterView, useRouter } from "vue-router";
const router = useRouter();

//v Components
import AuthSlider from "@/components/AuthSlider.vue";
import LoginFormInput from "@/components/LoginFormInput.vue";

//v Assets
import ButtonAni from "@/assets/loading-button-simple.json";

//v Vue3Lottie Animation Library
import { Vue3Lottie } from "vue3-lottie";

//v Vuelidate validation Library
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, sameAs, minLength } from "@vuelidate/validators";

//v Pinia Store: Auth
import { useAuthStore } from "@/stores/auth";
const authStore = useAuthStore();

//v View State
const buttonAnimation = ref(ButtonAni);
const isSendingRequest = ref(false);
const formData = reactive({
  passwordVal: "",
  passwordConfVal: "",
});
//v DOM Refs
const submitBtn = ref(null);
const messageContent = ref("");

//v From Validation Rules
const rules = computed(() => {
  return {
    passwordVal: {
      minLengthPassword: helpers.withMessage(
        "Password should be at least 8 characters long!",
        minLength(8)
      ),
      required: helpers.withMessage("Field Is Required!", required),
    },
    passwordConfVal: {
      sameAs: helpers.withMessage(
        "Password and Confirm Password must match!",
        sameAs(formData.passwordVal)
      ),
      required: helpers.withMessage("Field Is Required!", required),
    },
  };
});
//v useVuelidate state
const v$ = useVuelidate(rules, formData);

//v Sign up Submit Function
async function onSubmitForm(e) {
  // console.log(formData);
  //v validate inputs
  const validationResult = await v$.value.$validate();
  if (validationResult) {
    //v Form is Valid
    isSendingRequest.value = true;
    submitBtn.value.disabled = true;
    //v mimic sending request
    let data = {
      reset_password_token: router.currentRoute.value.query.reset_token,
      new_password: formData.passwordVal,
      confirm_new_password: formData.passwordConfVal,
    };
    // console.log(data);
    try {
      const res = await fetch(`${global.API_URL}/update-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      let respone = await res.json();
      // console.log(respone);
      messageContent.value = respone.data;
      const timeoutId = setTimeout(function () {
        // Your code to execute after 3 seconds goes here
        if (messageContent.value == "new password saved.") {
          router.push("login");
        }
        messageContent.value = "";
      }, 3000);
      timeoutId();
      clearTimeout(timeoutId);
      // v mimic sending request
      setTimeout(() => {
        isSendingRequest.value = false;
        submitBtn.value.disabled = false;
      }, 1500);
    } catch (err) {
      // console.log(err);
    }
  } else {
    //   //v Form is invalid
  }
}
</script>

<style scoped>
/* transition for auth forms; login, sign up, change password, forgot password, org-info */
.auth-form-enter-active,
.auth-form-leave-active {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.auth-form-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.auth-form-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.button-switch-enter-active,
.button-switch-leave-active {
  transition: opacity 0.3s ease-in-out, transform 0.4s ease-in-out;
}

.button-switch-enter-from {
  opacity: 0;
  transform: translateX(-100px);
}

.button-switch-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
</style>
